//Angular
import { Component, OnInit, ViewContainerRef,Compiler, Inject } from "@angular/core";

//Services
import { NewsletterService } from "./../../../../services/cms/newsletter.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { RoutesService } from "../../../../services/core/routes.service";

import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: "dy-newsletter",
    template: ""

})

export class NewsletterComponent implements OnInit 
{
    constructor
    (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private templateService: TemplateService,
        @Inject('isBrowser') private isBrowser: boolean
    ) {}

    subManager = new Subscription();

    ngOnInit() 
    {
        if(!this.isBrowser)
            return;

        let pageTemplateSub = this.templateService.getComponentTemplate("newsletterPageTemplate").subscribe(result => {

            var templateHtml = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(templateHtml);
            
            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        });

        this.subManager.add(pageTemplateSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(template: string) {

        @Component({
            template: template
        })

        class ChildComponent implements OnInit 
        {
            constructor
            (
                private newsletterService: NewsletterService,
                private routesService: RoutesService
            ) {}

            private newsletterSubmitted: boolean;
            private privacySubmitted: boolean;
            private alreadySubscribed: boolean;
            private successfullySubscribed: boolean;
            private isCaptchaInvalid = true;
            public verified: any;
            public siteKey: string = "6LcTlhYTAAAAAADnzMzRAmFtNPyHxr-IvkwXfCZ1";
            public theme: string = "light";
            private spinnerNewslatter: boolean = false;
            private model = {
                Email: "",
                CheckboxFooter: false
            };
            private privacyPageNameNewsletter: string[] = this.routesService.getRoutePath('INFO PRIVACY');
            
            subManager = new Subscription();
            
            ngOnInit() {
            }

            onSubmit(form) 
            {
                this.spinnerNewslatter = true;

                if (form) 
                {
                    let newsletterSub = this.newsletterService.newsletterSubscribe(this.model.Email).subscribe(result => 
                    {
                        if (result == "-1")
                        {
                            this.alreadySubscribed = true;
                            this.successfullySubscribed = false;
                            this.spinnerNewslatter = false;
                        }

                        else
                        {
                            this.alreadySubscribed = false;
                            this.successfullySubscribed = true;
                            this.spinnerNewslatter = false;
                        }
                    });

                    this.subManager.add(newsletterSub);
                }

                else 
                {
                    this.spinnerNewslatter = false;                       
                }
            }
            
            setVerified(data) 
            {
                this.isCaptchaInvalid = !data;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

       return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/footer/widget/newsletter.component.ts